import { render } from "./Sobre.vue?vue&type=template&id=21321e8e&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"

import "./sobre.scss?vue&type=style&index=0&id=21321e8e&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21321e8e"]])

export default __exports__